import { render, staticRenderFns } from "./Potential.vue?vue&type=template&id=55449fff&scoped=true"
import script from "./Potential.vue?vue&type=script&lang=js"
export * from "./Potential.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55449fff",
  null
  
)

export default component.exports